import axios from 'axios'

const API_PATH = 'api/v2/admins/products/images'

const ProductImageApiV2 = {
  /**
   * Get All Images of a particular Product
   * @param {number} id - productable id
   */
  get: async ({
    productable_id,
    productable_type
  }) => {
    const body = { productable_id, productable_type }

    const response = await axios.get(API_PATH, { params: body })
    return response
  },

  /**
   * Upload image data
   * @param {number} id - Product Id
   * @param {array} image - Image File
   * @param {array} isCover - a boolean to tell if the upload image is going to be the cover image
   */
  upload: async ({
    productable_id,
    productable_type,
    images,
    cover
  }) => {

    const formData = new FormData()

    formData.append('productable_id', productable_id)
    formData.append('productable_type', productable_type)

    images.forEach( (image) => {
      formData.append('images[]', image)
    })
    if (cover !== null) {
      formData.append('cover', cover)
    }

    const response = await axios.post(API_PATH, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return response
  },

  /**
   * Delete an image
   * @param {number} image_id - The id of the image that's to be deleted
   */
  delete: async ({
    image_id
  }) => {
    const path = `${API_PATH}/${image_id}`

    const response = await axios.delete(path)
    return response
  },

  /**
   * Set an image as a cover
   * @param {number} image_id - The id of the image that's to be deleted
   */
  set_as_cover: async ({
    image_id
  }) => {
    const path     = `${API_PATH}/${image_id}/cover`
    const response = await axios.patch(path)
    return response
  },

  /**
   * Set an image as a product's defect image
   * @param {number} image_id - The id of the image that's to be updated as defect image`
   */
  set_defect: async ({
    image_id
  }) => {
    const path     = `${API_PATH}/${image_id}/defect`
    const response = await axios.patch(path)
    return response
  },

  /**
   * Re-arrange productable images order
   * @param {object} newImages - images with new order based on drag and drop
   * @param {number} productable_id - productable id that owns the image
   * @param {string} productable_type - productable type that owns the image
   */
  rearrangeOrder: async ({
    newImages,
    productable_id,
    productable_type
  }) => {
    const params   = {
      images           : newImages,
      productable_id   : productable_id,
      productable_type : productable_type
    }
    const path     = `${API_PATH}/rearrange_order`
    const response = await axios.patch(path, params)
    return response
  }
}

export default ProductImageApiV2
